import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#1677FF',
  layout: 'mix',
  title: ' ',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  pwa: true,
  logo: 'https://us.snapmaker.com/cdn/shop/files/20221021-102236_0dcd8765-e230-460b-8d2d-117f94b7892c.png',
  token: {},
  splitMenus: false,
};

export default Settings;
